export default __webpack_public_path__ + "static/media/well_7to21.8a593f7e.png";